import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CodeDialogOptions } from './code-dialog-options';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@design-system/buttons/button/button.component';

/**
 * A useful modal dialog in which to ensure a user sees a message.
 * See {@link OnScreenMessagingService#openCodeDialog} for usage
 */
@Component({
  templateUrl: './code-dialog.component.html',
  styleUrls: ['./code-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent
  ]
})
export class CodeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: CodeDialogOptions
  ) {}

  close = () => this.dialogRef.close();
}
